var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import useStyles from './style';
import { Grid } from '@material-ui/core';
import classNames from 'classnames';
var MultiToggle = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var classes = useStyles();
    var handleChange = useCallback(function (value) {
        if (!disabled) {
            onChange(value);
        }
    }, [disabled, onChange]);
    return (_jsx(Grid, __assign({ className: classes.container }, { children: options.map(function (option) {
            var _a;
            return (_jsx(Grid, __assign({ className: classNames((_a = {}, _a[classes.selectedOption] = option.value === value, _a), classes.option), onClick: function () { return handleChange(option.value); }, "data-testid": "multi-toggle-option-" + option.text, "data-selected": option.value === value }, { children: option.text }), option.value));
        }) }), void 0));
};
export default MultiToggle;
